// NEW_FILE_JUSTIFIED: Dialog for displaying AI-extracted leads from a Gmail thread with dedup status
import { UserPlus } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import { ScrollArea } from '@/components/ui/scroll-area';
import type { IExtractedLeadsDialogProps } from '@/@types/leads';
import { ExtractedLeadRow } from './ExtractedLeadRow';

export function ExtractedLeadsDialog({
  open,
  onOpenChange,
  leads,
  gmailThreadId,
  orgServiceTypes,
  onLeadCreated,
}: IExtractedLeadsDialogProps) {
  const newLeadsCount = leads.filter(l => !l.existingLead).length;
  const existingCount = leads.filter(l => l.existingLead).length;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg max-h-[80vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <UserPlus className="w-5 h-5" />
            {leads.length} Lead{leads.length !== 1 ? 's' : ''} Found
          </DialogTitle>
          <div className="flex items-center gap-2 mt-1">
            {newLeadsCount > 0 && (
              <Badge variant="default" className="text-xs">
                {newLeadsCount} new
              </Badge>
            )}
            {existingCount > 0 && (
              <Badge variant="secondary" className="text-xs">
                {existingCount} already exist
              </Badge>
            )}
          </div>
        </DialogHeader>

        <ScrollArea className="flex-1 -mx-6 px-6">
          <div className="space-y-2 py-2">
            {leads.map((lead, index) => (
              <ExtractedLeadRow
                key={index}
                lead={lead}
                index={index}
                gmailThreadId={gmailThreadId}
                orgServiceTypes={orgServiceTypes}
                onLeadCreated={onLeadCreated}
              />
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
